var _circle, _circle2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValores4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 150,
    viewBox: "0 0 155 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 76,
    r: 72,
    stroke: "#0885C7",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFCD00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9365 26.925V22.175C24.9365 21.8833 24.9449 21.5708 24.9615 21.2375C24.9865 20.8958 25.0199 20.5417 25.0615 20.175L20.249 26.925H24.9365ZM30.1865 26.925V29.1C30.1865 29.2917 30.1199 29.4583 29.9865 29.6C29.8615 29.7417 29.6782 29.8125 29.4365 29.8125H28.3115V34H24.9365V29.8125H17.6115C17.3699 29.8125 17.149 29.7375 16.949 29.5875C16.7574 29.4375 16.6365 29.25 16.5865 29.025L16.1865 27.1125L24.6115 15.7875H28.3115V26.925H30.1865Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8341 71.1465H49.1765C47.3126 71.1465 45.9825 72.6258 46.1575 74.4728L46 103.28C46 103.368 46 103.446 46.0175 103.525C46.28 105.442 48.0389 107 49.9554 107H68.6646C70.4935 107 71.7886 105.573 71.6748 103.779L67.6145 73.7725C67.597 73.7812 67.5707 73.79 67.5532 73.7988C66.9756 72.2757 65.4618 71.1465 63.8341 71.1465Z",
    fill: "#0885C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.965 83.5848C114.781 81.4052 113.679 79.8121 112.244 78.6654C113.329 77.8951 113.968 76.7747 114.108 75.3654C114.291 73.4747 113.801 70.516 111.815 68.3715C110.809 67.286 109.006 65.9993 106.136 65.9993H92.7907C92.7645 64.0648 92.7644 61.0361 92.9045 58.3489C93.1057 54.4624 90.9355 49.7356 88.7916 47.2496C87.6627 45.9366 86.5164 45.2101 85.3875 45.07C85.02 45.0263 84.6437 45 84.2674 45C81.8085 45 78.9032 45.9804 78.3344 48.1425C78.0806 49.0791 78.3169 50.0682 78.5619 51.1186C78.8857 52.5104 79.297 54.2348 78.8682 56.6507C78.1419 60.7473 71.9463 70.6561 69.9424 72.4768L74.1165 103.35C76.8643 104.418 83.2173 106.737 86.5601 106.737H103.248C104.386 106.737 108.183 106.492 109.321 103.297C109.863 101.757 109.662 100.312 109.128 99.0695C109.12 98.9469 109.12 98.8419 109.111 98.7806C109.111 98.7543 109.111 98.7281 109.102 98.6931C111.185 98.1329 112.532 96.7498 112.891 94.6928C113.32 92.2156 112.576 90.4999 111.832 89.4583C114.046 88.4341 115.201 86.3683 114.965 83.5848Z",
    fill: "#0885C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 62,
    fill: "white",
    transform: "translate(46 45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValores4);
export default __webpack_public_path__ + "static/media/valores_4.a5fcfd9fa36e4ac65bf45eefface2583.svg";
export { ForwardRef as ReactComponent };